import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {DataService} from '../../services/data.service';
import {ApplicationService} from '../../services/application.service';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcSecurityService} from 'exc-security-v2';
import {ExgModalService, ExgOverlayService} from 'exc-controls-v2';
import {ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {ITaskSummaryData} from '../../misc/interfaces/ITaskSummaryData';
import {ICaseSummaryData} from '../../misc/interfaces/ICaseSummaryData';
import {ExgApplicationEventEmitter} from '../../misc/classes/ExgApplicationEventEmitter';
import {ExgEventArgs} from '../../misc/classes/ExgEventArgs';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {ExgApplicationTab} from 'exc-tab-v2';
import {CalculationVersionComponent} from '../../Calculation/calculation-version/calculation-version.component';

@Component({
  selector: 'app-report-doc-selector',
  templateUrl: './report-doc-selector.component.html',
  styles: [
  ]
})
export class ReportDocSelectorComponent extends ExcTranslation implements OnInit{
  @Input() insertSummaryData: ITaskSummaryData | ICaseSummaryData | undefined;
  @Input() vorgOrAuNr = '';
  @Input() selectKey = '';
  @Output() choseObj = new EventEmitter<any>();
  @Output() deleteChosenObj = new EventEmitter<any>();
  selectedSummary: ITaskSummaryData | ICaseSummaryData | undefined;
  Events = new ExgApplicationEventEmitter();

  selectedCalcs: {[placeholder: string]: any} = {};
  selectedQuestion: {[placeholder: string]: any} = {};
  selectedPhotoDocs: {[placeholder: string]: any} = {};
  selectedAttachments: {[placeholder: string]: any} = {};
  selectedReceipts: {[placeholder: string]: any} = {};

  sidemenu = [
    { caption: 'Kalkulation', icon: 'fa-file-spreadsheet fal', selectedCount: 0, disabled: false },
    { caption: 'Fragebögen', icon: 'fa-clipboard-list fal',          selectedCount: 0, disabled: false },
    { caption: 'Bilddokumentation', icon: 'fa-file-image fal', selectedCount: 0, disabled: false },
    { caption: 'Anhänge', icon: 'fa-paperclip fal',            selectedCount: 0, disabled: false, subItems: [] as any[] },
    { caption: 'Unfertige Belege', icon: 'fa-file-invoice-dollar fal',          selectedCount: 0, disabled: false },
    { caption: 'Unfertige Stellungnahmen', icon: 'fa-file-lines fal',          selectedCount: 0, disabled: false },
  ];

  selectedMenuIndex = 0;
  tabinstance: any;

  userType: number | any;

  /*Table/List Configs*/

  calcConfig = {
    calcSelection: [] as any [],
    calcList: {
      state: 1,
      searchValue: '',
      data: [] as any [],
      MetaInfo: {
        dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
        dataSort: {} as IExcDataSort,
        dataFilter: {} as IExcDataFilter,
      } as IExcMetaInfo,

      ready: () => {
        if (this.calcConfig.calcList.data?.length > 0) {
          this.calcConfig.calcList.state = 0;
        } else {
          this.calcConfig.calcList.state = 2;
        }
      },
      search: (value: string) => {
        this.calcConfig.calcList.searchValue = value;
        this.calcConfig.calcList.loadData();
      },
      loadData: () => {
        this.calcConfig.calcList.state = 1;
        this.calcConfig.calcList.data = [];
        const url = 'CalculationVersionR_List';
        this.excRest
          .sget(
            this.excRest.computeUrl(url, {
              FKID: this.selectedSummary?.ID, fts: this.calcConfig.calcList.searchValue}),
            'CalcVersList',
            {
              MetaInfo: {
                dataPaging: this.calcConfig.calcList.MetaInfo.dataPaging,
                dataSort: this.calcConfig.calcList.MetaInfo.dataSort,
                dataFilter: this.calcConfig.calcList.MetaInfo.dataFilter
              }
            }
          )
          .subscribe((response) => {
            if (response.success && response.data?.CalculationVersion?.length > 0) {
              this.markSelectedInArray(response.data.CalculationVersion, this.selectedCalcs, 'cvID');
              this.calcConfig.calcList.data = response.data.CalculationVersion;
            }
            this.calcConfig.calcList.ready();
          });
      }
    }
  };
  questConfig = {
    questSelection: [] as any [],
    questList: {
      state: 1,
      searchValue: '',
      data: [] as any [],
      MetaInfo: {
        dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
        dataSort: {} as IExcDataSort,
        dataFilter: {} as IExcDataFilter,
      } as IExcMetaInfo,

      ready: () => {
        if (this.questConfig.questList.data?.length > 0) {
          this.questConfig.questList.state = 0;
        } else {
          this.questConfig.questList.state = 2;
        }
      },
      search: (value: string) => {
        this.questConfig.questList.searchValue = value;
        this.questConfig.questList.loadData();
      },
      loadData: () => {
        this.questConfig.questList.state = 1;
        this.questConfig.questList.data = [];
        const url = 'QuestionnaireVersionR_List';
        this.excRest
          .sget(
            this.excRest.computeUrl(url, {FKID: this.selectedSummary?.ID, fts: this.questConfig.questList.searchValue}),
            'QuestVersList',
            {
              MetaInfo: {
                dataPaging: this.questConfig.questList.MetaInfo.dataPaging,
                dataSort: this.questConfig.questList.MetaInfo.dataSort,
                dataFilter: this.questConfig.questList.MetaInfo.dataFilter
              }
            }
          )
          .subscribe((response) => {
            if (response.success && response.data?.QuestionnaireVersion?.length > 0) {
              this.markSelectedInArray(response.data.QuestionnaireVersion, this.selectedQuestion, 'qverID');
              this.questConfig.questList.data = response.data.QuestionnaireVersion;
            }
            this.questConfig.questList.ready();
          });
      }
    }
  };
  photoDocConfig = {
    photoDocSelection: [] as any [],
    photoDocList: {
      state: 1,
      searchValue: '',
      data: [] as any [],
      MetaInfo: {
        dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
        dataSort: {} as IExcDataSort,
        dataFilter: {} as IExcDataFilter,
      } as IExcMetaInfo,

      ready: () => {
        if (this.photoDocConfig.photoDocList.data?.length > 0) {
          this.photoDocConfig.photoDocList.state = 0;
        } else {
          this.photoDocConfig.photoDocList.state = 2;
        }
      },
      search: (value: string) => {
        this.photoDocConfig.photoDocList.searchValue = value;
        this.photoDocConfig.photoDocList.loadData();
      },
      loadData: () => {
        this.photoDocConfig.photoDocList.state = 1;
        this.photoDocConfig.photoDocList.data = [];
        const url = 'PhotoDocumentationR_List';
        this.excRest
          .sget(
            this.excRest.computeUrl(url, {FKID: this.selectedSummary?.ID, fts: this.photoDocConfig.photoDocList.searchValue}),
            'PhotoDocList',
            {
              MetaInfo: {
                dataPaging: this.photoDocConfig.photoDocList.MetaInfo.dataPaging,
                dataSort: this.photoDocConfig.photoDocList.MetaInfo.dataSort,
                dataFilter: this.photoDocConfig.photoDocList.MetaInfo.dataFilter
              }
            }
          )
          .subscribe((response) => {
            if (response.success && response.data?.length > 0) {
              this.markSelectedInArray(response.data, this.selectedPhotoDocs, 'pdID');
              this.photoDocConfig.photoDocList.data = response.data;
            }
            this.photoDocConfig.photoDocList.ready();
          });
      }
    }
  };
  attConfig = {
    selectedFolderKey: '' as any,
    attachmentSelection: [] as any[],
    attachmentJagTable: {
      jagdata: [] as any[],
      state: 1,
      searchValue: '',
    data: [] as any [],
      MetaInfo: {
        dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
        dataSort: {} as IExcDataSort,
        dataFilter: {} as IExcDataFilter,
      } as IExcMetaInfo,

      ready: () => {
        if (this.attConfig.attachmentJagTable.jagdata?.length > 0) {
          this.attConfig.attachmentJagTable.state = 0;
        } else {
          this.attConfig.attachmentJagTable.state = 2;
        }
      },
      search: (value: string) => {
        this.attConfig.attachmentJagTable.searchValue = value;
        this.attConfig.attachmentJagTable.loadData();
      },
      loadData: () => {
        this.attConfig.attachmentJagTable.state = 1;
        this.attConfig.attachmentJagTable.jagdata = [];
        const url = 'DocumentR_List_Jag';
        this.excRest
          .sget(
            this.excRest.computeUrl(url, {objID: this.selectedSummary?.ID, fts: this.attConfig.attachmentJagTable.searchValue}),
            'docJagList',
            {
              MetaInfo: {
                dataPaging: this.attConfig.attachmentJagTable.MetaInfo.dataPaging,
                dataSort: this.attConfig.attachmentJagTable.MetaInfo.dataSort,
                dataFilter: this.attConfig.attachmentJagTable.MetaInfo.dataFilter
              }
            }
          )
          .subscribe((response) => {
            if (response.success && response.data) {
              this.markSelectedDocumentsGrouped(response.data.AttachmentsJag, this.selectedAttachments);
              this.attConfig.attachmentJagTable.jagdata = this.filterAttachmentsJag(response.data.AttachmentsJag);
            }
            this.attConfig.attachmentJagTable.ready();
          });
      }
    },
    showAttachmentPreview: (dokID?: string): void => {
      this.appSvc.Document.Preview.OpenModal({objID: this.selectedSummary?.ID, attID: dokID}, {Events: this.Events});
    },
    showAttachmentUpdateModal: (node: any): void => {
      if ((node.dokCRL === this.excSecurity.UserLogin) || this.userType === 1) {
        if (this.excSecurity.isFeatured('DOCUMENTEDIT')) {
          this.appSvc.Document.Update.OpenModal({dokID: node.dokID}, {Events: this.Events});
        }
      }
    },
    openReport: (rowID: any): void => {
      this.appSvc.Report.Open(rowID, {Events: this.Events});
    },
    openQuestionnaire: (row: any): void => {
      const data = { qcnfID: row.dokGroesse, qverID: row.dokID, isTest: false, qverName: row.dokName};
      this.overlayService.close();
      this.appSvc.QuestionnaireVersion.OpenTab(data);
    }
  };
  rcptConfig = {
    selectedFolderKey: '' as any,
    receiptSelection: [] as any[],
    receiptList: {
      data: [] as any[],
      MetaInfo: {
        dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
        dataSort: {} as IExcDataSort,
        dataFilter: {} as IExcDataFilter,
      } as IExcMetaInfo,
      state: 1,
      searchValue: '',
      ready: () => {
        if (this.rcptConfig.receiptList.data?.length > 0) {
          this.rcptConfig.receiptList.state = 0;
        } else {
          this.rcptConfig.receiptList.state = 2;
        }
      },
      search: (value: string) => {
        this.rcptConfig.receiptList.searchValue = value;
        this.rcptConfig.receiptList.loadData();
      },
      loadData: () => {
        this.rcptConfig.receiptList.state = 1;
        this.rcptConfig.receiptList.data = [];
        const url = 'ReceiptR_List_FKID';
        this.excRest
          .sget(
            this.excRest.computeUrl(url, {
              FKID: this.selectedSummary?.ID,
              fts: this.rcptConfig.receiptList.searchValue
            }),
            'docJagList',
            {
              MetaInfo: {
                dataPaging: this.rcptConfig.receiptList.MetaInfo.dataPaging,
                dataSort: this.rcptConfig.receiptList.MetaInfo.dataSort,
                dataFilter: this.rcptConfig.receiptList.MetaInfo.dataFilter
              }
            }
          )
          .subscribe((response) => {
            if (response.success && response.data) {
              this.markSelectedReceipts(response.data.Receipts, this.selectedReceipts);
              this.rcptConfig.receiptList.data = this.filterReceiptsJag(response.data.Receipts);
            }
            this.rcptConfig.receiptList.ready();
          });
      },
      onDblClickCheckView: (rcptID: any, rcptStatement = false): void => {
        if (rcptID) {
          if (!rcptStatement) {
            this.appSvc.Receipt.Checkview.OpenTab(
              rcptID
            );
          } else if (rcptStatement) {
            this.appSvc.Receipt.StatementCheckview.OpenTab(
              rcptID
            );
          }
        }
      }
    }
  };

  attFolderStates: { [key: string]: boolean } = {};
  rcptFolderStates: { [key: string]: boolean } = {};

  private _reportCommentary = {
    commentary: [] as any[],
    commentaryDate: [] as any[],
    reportType: '',
    FKID: ''
  };

  constructor(
    private dataSvc: DataService,
    public appSvc: ApplicationService,
    public enmSrv: EnumerationService,
    public excSecurity: ExcSecurityService,
    public overlayService: ExgOverlayService,
    private modal: ExgModalService,
    public excRest: ExcRestService) {
    super();
  }

  ngOnInit(): void {
    this.registerEvents();
    this.userType = Number(this.appSvc.UserAttributes()?.type) || 2;
    if (this.insertSummaryData) {
      this.selectedSummary = this.insertSummaryData;
      this.calcConfig.calcList.data = this.selectedSummary?.calculationVersion?.data || [];
      this.calcConfig.calcList.ready();
      this.questConfig.questList.data = this.selectedSummary?.questionnaireVersion?.data || [];
      this.questConfig.questList.ready();
      this.photoDocConfig.photoDocList.data = this.selectedSummary?.photoDocumentation?.data || [];
      this.photoDocConfig.photoDocList.ready();
      this.attConfig.attachmentJagTable.jagdata = this.filterAttachmentsJag(this.selectedSummary?.attachmentJagTable?.jagdata);
      this.attConfig.attachmentJagTable.ready();
      this.rcptConfig.receiptList.data = this.filterReceiptsJag(this.selectedSummary?.receiptList?.data);
      this.rcptConfig.receiptList.ready();
    }
    else {
      this.tabinstance.close();
    }
  }

  private registerEvents(): void {
    this.Events.ReportBuilder.PreviewOverlay.Closed.subscribe((evt: ExgEventArgs) => {
      if (evt.data.pdID) {
        this.photoDocConfig.photoDocList.loadData();
      }
      else if (evt.data.qverID) {
        this.questConfig.questList.loadData();
      }
      else if (evt.data.cvID) {
        this.calcConfig.calcList.loadData();
      }
      else if (evt.data.rcptID) {
        this.rcptConfig.receiptList.loadData();
      }
    });
  }

  selectMenuItem(index: any): void {
    this.selectedMenuIndex = index;
    this.attConfig.selectedFolderKey = undefined;
    this.rcptConfig.selectedFolderKey = undefined;
  }
  selectionHandler( element: any, event: any, idKey: string, targetMap: { [key: string]: any },
                    sidemenuIndex: number): void {
    const id = element[idKey];
    if (event) {
      targetMap[id] = element;
      this.choseObj.emit(element);
    } else {
      delete targetMap[id];
      this.deleteChosenObj.emit(element);
    }
    this.sidemenu[sidemenuIndex].selectedCount = Object.keys(targetMap).length;
  }
  markSelectedInArray(resultArray: any[], selectedMap: {[key: string]: any}, keyField: string): void {
    for (const key in selectedMap) {
      if (selectedMap[key]) {
        const selectedItem = selectedMap[key];
        const keyValue = selectedItem[keyField];

        const foundItem = resultArray.find(item => item[keyField] === keyValue);
        if (foundItem) {
          foundItem.selectedInUI = true;
        } else {
          this.modal.showToast('Es ist ein Fehler aufgetreten!', 'md-toast', 'fas fa-exclamation');
        }
      }
    }
  }
  /*Calculation*/
  cvSelection(cvElement: any, event: any): void {
    this.selectionHandler(  cvElement, event, 'cvID',
                            this.selectedCalcs, 0);
  }
  openCalculationVersion(cvElement: any): void {
    const data = {cv_ctID: cvElement.ctID, cv_fkID: cvElement.cv_FKID};
    if (cvElement.cvID) {
      Object.assign(data, {cvID: cvElement.cvID});
    }

    const tab = new ExgApplicationTab(
      cvElement.cvName ?? cvElement.ctName,
      CalculationVersionComponent,
      data,
      data.cv_ctID
    );
    tab.Open();
  }
  openCalculationVersionModal(cvElement: any): void {
    this.modal.show('ModalCalculationVersionComponent', cvElement)
      .subscribe((retValue: any) => {
        if (retValue) {
          if (retValue.del) {
            this.excRest.delete(
              this.excRest.computeUrl(
                'CalculationVersionD', {
                  cvID: cvElement.cvID
                }
              ), {
                cvID: cvElement.cvID,
                cvUPT: cvElement.cvUPT,
              }).subscribe((response: any) => {
              if (response?.success) {
                this.modal
                  .showToast('Kalkulation gelöscht'
                    , 'md-toast bg-green'
                    , 'far fa-check');
                this.cvSelection(cvElement, false);
                this.calcConfig.calcList.loadData();
              }
            });
          }
          else {
            this.excRest.put(
              this.excRest.computeUrl(
                'CalculationVersionU', {
                  cvID: cvElement.cvID
                }
              ), retValue).subscribe((response: any) => {
              if (response?.success) {
                this.cvSelection(cvElement, false);
                this.calcConfig.calcList.loadData();
              }
            });
          }
        }
      });
  }

  /*Questionnaire*/
  qverSelection(qverElement: any, event: any): void {
    this.selectionHandler(  qverElement, event, 'qverID',
                            this.selectedQuestion, 1);
  }
  openModalQuestionnaireVersion(qverElement: any): void {
    this.modal.show('ModalQuestionnaireVersionComponent', { ...qverElement, isEdit: true})
      .subscribe((retValue: any) => {
        if (retValue) {
          this.qverSelection(qverElement, false);
          this.questConfig.questList.loadData();
          }
      });
  }
  openQuestionnaireVersion(qverElement: any): void {
    const data = {
      qcnfID: qverElement.qver_qcfgID
      , qverID: qverElement.qverID
      , isTest: false
      , qverName: qverElement.qverName};

    this.appSvc.QuestionnaireVersion.OpenTab(data);
  }

  /*Bilddokumentation*/
  pdSelection(pdElement: any, event: any): void {
    this.selectionHandler(  pdElement, event, 'pdID',
                            this.selectedPhotoDocs, 2);
  }
  openPhotoDocPreview(pd: any): void {
    this.appSvc.PhotoDocumentation.PreviewModal({...pd, ...{ FKID: pd.pd_FKID, pdIsPreview: true }}, {Events: this.Events});
  }
  openPhotoDocEditTextModal(isUpload: boolean = false, editModel: any = {}): void {
    this.modal.show('ModalFinishPhotoDocComponent', { isUpload, editModel }).subscribe( (rslt: any) => {
      if ( rslt ) {
        const url = this.excRest.computeUrl('PhotoDocumentationU', {pdID: editModel.pdID});
        const uiModel: any = {
          pdName: rslt.pdName,
          pdUPT: editModel.pdUPT,
          pdDescription: rslt.pdDescription,
          pdPhotoDocumentationStatus_enmIdent: rslt.pdPhotoDocumentationStatus_enmIdent
        };
        this.excRest.put(url, uiModel).subscribe((res: any) => {
          if (res?.success) {
            this.pdSelection(editModel, false);
            this.modal.showToast(
              'Datenänderung erfolgreich!'
              , 'md-toast', 'fas fa-check');
            this.photoDocConfig.photoDocList.loadData();
          }
          else {
            this.modal.showToast('Datenänderung fehlgeschlagen!', 'md-toast', 'fas fa-exclamation');
          }
        });
      }
    });
  }

  /*Attachement*/
  attSelection(dokElement: any, event: boolean): void {
    this.selectionHandler(  dokElement, event, 'dokID',
                            this.selectedAttachments, 3);
  }
  filterAttachmentsJag(jagdata: any[]): any[] {
    const folders = (jagdata ?? []).map(folder => {
      const docs = (folder.documents ?? []).filter((doc: any) => {
        const m = doc.dokMIME?.toLowerCase() || '';
        const n = doc.dokName?.toLowerCase() || '';
        // const q = doc.dokMode?.toLowerCase() || '';
        return (
          m === 'application/pdf' ||
          m === 'application/msword' ||
          m.startsWith('image/') ||
          n.endsWith('.pdf') ||
          n.endsWith('.docx')
          // || q === 'fragebogen'
        );
      });

      return {
        ...folder,
        documents: docs,
        dokFolderCount: docs.length
      };
    }).filter(folder => folder.dokFolderCount > 0);

    // Nur sidemenu items für Folder mit Inhalten setzen
    this.sidemenu[3].subItems = folders.map(folder => ({
      ...folder,
      selectedCount: this.getSelectedDocumentCount(folder),
      key: this.getAttFolderKey(folder)
    }));

    return folders;
  }
  selectAttSubFolder(folder: any): void {
    this.selectMenuItem(3);
    this.attConfig.selectedFolderKey = this.getAttFolderKey(folder);
  }
  getAttFolderKey(folder: any): string {
    return `${folder.source}_${folder.dok_enmIdent_DokTyp || 'none'}`;
  }
  toggleAttFolder(folder: any): void {
    const key = this.getAttFolderKey(folder);
    this.attFolderStates[key] = !this.attFolderStates[key];
  }
  isAttFolderExpanded(folder: any): boolean {
    const key = this.getAttFolderKey(folder);
    return this.attFolderStates[key];
  }
  trackByAttFolderKey = (index: number, folder: any): string => {
    return `${folder.source}_${folder.dok_enmIdent_DokTyp || 'none'}`;
  }
  getSelectedDocumentCount(folder: any): number {
    return (folder?.documents || []).filter((doc: any) => doc.selectedInUI).length;
  }
  markSelectedDocumentsGrouped(docGroups: any[], selectedMap: {[key: string]: any}): void {
    const foundKeys = new Set<string>();

    for (const group of docGroups) {
      group.documents?.forEach((doc: any) => {
        for (const sel of Object.values(selectedMap)) {
          if (sel.dokID === doc.dokID) {
            doc.selectedInUI = true;
            foundKeys.add(sel.dokID);
          }
        }
      });
    }

    for (const sel of Object.values(selectedMap)) {
      if (!foundKeys.has(sel.dokID)) {
        this.modal.showToast('Es ist ein Fehler aufgetreten!', 'md-toast', 'fas fa-exclamation');
      }
    }
  }

  /*Belege*/
  filterReceiptsJag(jagdata: any[]): any[] {
    const folders = (jagdata ?? []).map(folder => {
      const filteredReceipts = (folder.receipts ?? []).filter((receipt: any) =>
        receipt.rcpt_enmIdent_ReceiptStatus !== 10 // filter out "freigegebene"
      );

      return {
        ...folder,
        receipts: filteredReceipts,
        refItem_rcptIDs: filteredReceipts.length
      };
    }).filter(folder => folder.refItem_rcptIDs > 0);

    const toSubItem = (folder: any) => ({
      ...folder,
      selectedCount: this.getSelectedReceiptCount(folder),
      key: this.getRcptFolderKey(folder)
    });

    this.sidemenu[4].subItems = folders.filter(f => !f.refGroupStatement).map(toSubItem);
    this.sidemenu[5].subItems = folders.filter(f => f.refGroupStatement === true).map(toSubItem);

    return folders;
  }
  selectRcptSubFolder(folder: any, selectedMenuIndex = 4): void {
    this.selectMenuItem(selectedMenuIndex);
    this.rcptConfig.selectedFolderKey = this.getRcptFolderKey(folder);
  }
  getRcptFolderKey(folder: any): string {
    return `${folder.refGroupHeadline || 'none'}_${folder.refGroupDesc || 'none'}_${folder.refItem_rcptIDs || 'none'}`;
  }
  getRcptFolders(selectedMenuIndex = 4): any[] {
    return this.rcptConfig.receiptList.data
      .filter((folders: any) =>
        (folders.refGroupStatement === true && selectedMenuIndex === 5)
        ||
        (folders.refGroupStatement === false && selectedMenuIndex === 4)
      );
  }
  toggleRcptFolder(folder: any): void {
    const key = this.getRcptFolderKey(folder);
    this.rcptFolderStates[key] = !this.rcptFolderStates[key];
  }
  isRcptFolderExpanded(folder: any): boolean {
    const key = this.getRcptFolderKey(folder);
    return this.rcptFolderStates[key];
  }
  trackByRcptFolderKey = (index: number, folder: any): string => {
    return `${folder.refGroupHeadline || 'none'}_${folder.refGroupDesc || 'none'}_${folder.refItem_rcptIDs || 'none'}`;
  }
  getSelectedReceiptCount(folder: any): number {
    return (folder?.receipts || []).filter((rcpt: any) => rcpt.selectedInUI).length;
  }
  getReviewReasonsText(reviewReasonsJson: string): string {
    if (!reviewReasonsJson) { return ''; }
    try{
      const reasons = JSON.parse(reviewReasonsJson);
      return Array.isArray(reasons) ? reasons.filter(reason => reason.enmValue === true).map(reason => reason.enmText).join(', ') : '';
    } catch
    {
      return '';
    }
  }
  getRcptObjectString(receiptData: any): string {
    let rtValue = '';
    if (receiptData.rcptObject && receiptData.rcptObject.length > 0) {
      const rcptObjects = JSON.parse(receiptData.rcptObject);
      for (const objElement of rcptObjects) {
        rtValue += objElement.enmText + '; ';
      }
    }

    return rtValue;
  }
  markSelectedReceipts(receiptGroups: any[], selectedMap: {[key: string]: any}): void {
    const foundKeys = new Set<string>();
    for (const group of receiptGroups) {
      group.receipts?.forEach((receipt: any) => {
        for (const sel of Object.values(selectedMap)) {
          if (sel.rcptID === receipt.rcptID) {
            receipt.selectedInUI = true;
            foundKeys.add(sel.rcptID);
          }
        }
      });
    }

    for (const sel of Object.values(selectedMap)) {
      if (!foundKeys.has(sel.rcptID)) {
        this.modal.showToast('Es ist ein Fehler aufgetreten!', 'md-toast', 'fas fa-exclamation');
      }
    }
  }

  stripHtmlTags(value: string): string {
    const doc = new DOMParser().parseFromString(value, 'text/html');
    return doc.body.textContent || '';
  }

  openPreviewOverlay(anyElement: any): void {
    this.appSvc.ReportBuilder.ReportReview.OpenOverlay(anyElement, {Events: this.Events});
  }

  openMessageModal = (reportType: string, FKID: string): void => {
    /*1. ReportType speichern für Call im Modal*/
    this._reportCommentary.reportType = reportType;
    this._reportCommentary.FKID = FKID;

    const callName =
      this._reportCommentary.reportType === 'RECEIPT' ? 'ReceiptCommentary' : 'ReportCommentaryR_List';
    const pObj =
      this._reportCommentary.reportType === 'RECEIPT' ? {rcptID : this._reportCommentary.FKID} : {FKID: this._reportCommentary.FKID};

    /*1. ReportCommentary für obj holen*/
    this.excRest.get(this.excRest.computeUrl(callName, pObj)).subscribe((response: any) => {
      if (response?.success && response?.data ) {
        this._reportCommentary.commentary = response.data.Commentary;
        this._reportCommentary.commentaryDate = response.data.CommentaryDate;
        /* 2.Modal anzeigen*/
        this.modal
          .show('CommentaryModalComponent', {
            checkview: this,
          })
          .subscribe(() => {
            this._reportCommentary.commentary = [];
            this._reportCommentary.commentaryDate = [];
          });
      }
      else {
        /*Hat nicht funktioniert*/
        this.modal.showToast('Kommentare konnten nicht geladen werden!', 'md-toast', 'fas fa-exclamation');
        return;
      }
    });
  }
  loadCommentaryList = (): void => {
    const callName =
      this._reportCommentary.reportType === 'RECEIPT' ? 'ReceiptCommentary' : 'ReportCommentaryR_List';
    const pObj =
      this._reportCommentary.reportType === 'RECEIPT' ? {rcptID : this._reportCommentary.FKID} : {FKID: this._reportCommentary.FKID};

    /*1. ReportCommentary für obj holen*/
    this.excRest.get(this.excRest.computeUrl(callName, pObj)).subscribe((response: any) => {
      if (response?.success && response?.data ) {
        this._reportCommentary.commentary = response.data.Commentary;
        this._reportCommentary.commentaryDate = response.data.CommentaryDate;
      }
      else {
        /*Hat nicht funktioniert*/
        this.modal.showToast('Kommentare konnten nicht geladen werden!', 'md-toast', 'fas fa-exclamation');
        return;
      }
    });
  }

  /*für CommentaryModal, ist nicht unused*/
  commentaryCreate = (obj: { commText: string; commTyp: number }): void => {
    const callName =
      this._reportCommentary.reportType === 'RECEIPT' ? 'ReceiptCommentary' : 'ReportCommentaryC';
    const pObj =
      this._reportCommentary.reportType === 'RECEIPT' ? {rcptID : this._reportCommentary.FKID}
        : {FKID: this._reportCommentary.FKID, commReportType: this._reportCommentary.reportType};

    this.excRest
      .post(
        this.excRest.computeUrl(callName, pObj),
        obj
      )
      .subscribe((response: any) => {
        if (response?.success && response?.data ) {
          this.loadCommentaryList();
        }
        else {
          /*Hat nicht funktioniert*/
          this.modal.showToast('Kommentar konnte nicht gespeichert werden!', 'md-toast', 'fas fa-exclamation');
          return;
        }
      });
  }

  get commentary(): any[] {
    return this._reportCommentary.commentary;
  }

  get commentaryDate(): any[] {
    return this._reportCommentary.commentaryDate;
  }
}
